import React, { Fragment, useEffect, useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {
  Row,
  Input,
  Button,
  Card,
  CardBody,
  CustomInput,
  Label,
  NavItem,
  Col,
  CardHeader,
  TabContent,
  TabPane,
  Nav,
  CardTitle,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import {
  API_Urls,
  API_Sync_SABRE,
  API_Ingetration_Channels,
  API_RMS_SYNC_ROOMS,
} from '../../../../../constants/APIs';
import sync_sabre from '../../../../../assets/sync_sabre.png';
import RMSLogo from '../../../../../assets/rms.ico';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import Templates from './components/Templates';
import { ImagesImport } from './components/ImageImport';
//import LanguageTranslate from "./components/LanguageTranslate";
//import { RoomImport } from "./components/RoomImport";
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;
function Copilot({ propertyId, locale, email }) {
  const [urls, setUrls] = useState({
    url1: '',
    url2: '',
    url3: '',
  });
  const [urlList, setUrlList] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [ApiStateImport, setApiStateImport] = useState('default');
  const [ApiImport, setApiImport] = useState('default');
  const [selectedTab, setSelectedTab] = useState('textGeneration');
  const [sabreIntegration, setSabreIntegration] = useState();
  const [rmsIntegrations, setRMSIntegrations] = useState();
  const [sabreDetails, setSabreDetails] = useState({
    guestRooms: false,
    generalText: false,
    propertyDescription: false,
    policies: false,
    conactInfo: false,
    locationInfo: false,
  });
  const [isRMSRoomSelected, setIsRMSRoomSelected] = useState(false);

  useEffect(() => {
    let body = {
      channels: ['Sabre', 'RMSBookingEngine'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      // console.log(res.data);
      const sabreIntegrations = res.data.filter(
        (k) =>
          k.channel === 'Sabre' &&
          k.disabled === false &&
          k.properties.includes(propertyId)
      );
      setSabreIntegration(
        sabreIntegrations.length > 0 ? sabreIntegrations[0] : undefined
      );
      const rmsIntegrations = res.data.filter(
        (k) =>
          k.channel === 'RMSBookingEngine' &&
          k.disabled === false &&
          k.properties.includes(propertyId)
      );
      setRMSIntegrations(
        rmsIntegrations.length > 0 ? rmsIntegrations[0] : undefined
      );
    });
  }, [propertyId]);

  const handleSubmit = () => {
    setApiStateImport('processing');
    setUrlList([]);
    fetch(`${process.env.REACT_APP_MYMA_GPT_API}/website-url`, {
      method: 'Post',
      body: JSON.stringify([urls.url1, urls.url2, urls.url3]),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          setApiStateImport('success');
          console.log(data);
          let lst = [];
          data.map((m) => {
            lst.push({
              checked: true,
              url: m,
            });
          });
          console.log(lst);
          setIsShow(true);
          setUrlList(lst);
        } else {
          setApiStateImport('fail');
        }
      });
  };

  const handleRMS = () => {
    console.log(isRMSRoomSelected, 'isRMSRoomSelected');
    if (isRMSRoomSelected) {
      setApiImport('processing');
      const upload = {
        groupId: getGroupID(),
        propertyId: propertyId,
        integrationId: rmsIntegrations.id,
        channel: 'RMS',
        type: 'Admin',
      };
      AxiosAPI({
        method: 'post',
        url: `${API_RMS_SYNC_ROOMS}`,
        data: upload,
      })
        .then((res) => {
          setApiImport('success');
          NotificationManager.success(
            '',
            'The Import process has been initiated. Check Details in about 15 minutes.',
            3000,
            null,
            null,
            'success'
          );
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((err) => console.log('err', err));
    }
  };

  const handleSabre = () => {
    setApiImport('processing');
    const upload = {
      groupId: getGroupID(),
      propertyId: propertyId,
      integrationId: sabreIntegration.id,
      guestRooms: sabreDetails.guestRooms,
      languageCode: locale,
      contactInfo: sabreDetails.conactInfo,
      locationInfo: sabreDetails.locationInfo,
      policies: sabreDetails.policies,
      propertyDescription: sabreDetails.propertyDescription,
      type: 'OTA_HotelInfo',
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Sync_SABRE}`,
      data: upload,
    })
      .then((res) => {
        setApiImport('success');
        NotificationManager.success(
          '',
          'The Import process has been initiated. Check Details in about 15 minutes.',
          3000,
          null,
          null,
          'success'
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => console.log('err', err));
  };

  const handleUpload = () => {
    setApiImport('processing');
    let url = urlList.filter((f) => f.checked == true).map((m) => m.url);
    const upload = {
      groupId: getGroupID(),
      propertyId: propertyId,
      urls: url,
      languageCode: locale,
      email: email,
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Urls}/create`,
      data: upload,
    })
      .then((res) => {
        if (res.data.message !== undefined) {
          setApiImport('fail');
          NotificationManager.error(
            '',
            'Something went wrong.',
            3000,
            null,
            null,
            'error'
          );
        } else {
          setApiImport('success');
          NotificationManager.success(
            '',
            'The Import process has been initiated. Check Knowledge Hub in about 15 minutes.',
            3000,
            null,
            null,
            'success'
          );
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          setUrlList([]);
        }
      })
      .catch((err) => console.log('err', err));
  };
  const handleSelectedAll = (checked) => {
    console.log(checked);
    setIsShow(false);
    let urls = urlList;
    if (checked)
      urls = urls.map((m) => {
        m.checked = true;
        return m;
      });
    else
      urls = urls.map((m) => {
        m.checked = false;
        return m;
      });
    setUrlList(urls);
    console.log(urls);
    setIsShow(true);
  };
  const handleChange = (e, value) => {
    const values = urlList.map((elem, index) => {
      if (index == e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    console.log(values);
    setUrlList(values);
  };
  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <CardTitle>
            <b>
              Meet Sprint, our breakthrough automation to train Myma.ai Chatbot
              in 10x less time.
            </b>
            <br />
            Myma.ai’s Sprint works alongside you—to unleash creativity, unlock
            productivity, and drastically reduce the time it takes to train the
            Digital Assistant.
          </CardTitle>
        </Colxx>
      </Row>
      <CardHeader
        className="mb-2"
        style={{ marginLeft: '-1.25rem', marginRight: '-1.25rem' }}
      >
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <style>{style_css}</style>
          <NavItem
            className="text-center"
            style={{ width: 'auto', background: '' }}
          >
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'textGeneration',
                'nav-link': true,
              })}
              onClick={() => {
                setSelectedTab('textGeneration');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${
                    selectedTab === 'textGeneration'
                      ? 'var(--theme-color-1)'
                      : 'black'
                  }`,
                }}
              >
                Text Generation
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'imageImport',
                'nav-link': true,
              })}
              onClick={() => {
                setSelectedTab('imageImport');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${
                    selectedTab === 'imageImport'
                      ? 'var(--theme-color-1)'
                      : 'black'
                  }`,
                }}
              >
                Image Import
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'templates',
                'nav-link': true,
              })}
              onClick={() => {
                setSelectedTab('templates');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${
                    selectedTab === 'templates'
                      ? 'var(--theme-color-1)'
                      : 'black'
                  }`,
                }}
              >
                Templates
              </span>
            </NavLink>
          </NavItem>
          {sabreIntegration !== undefined && (
            <NavItem className=" text-center" style={{ width: 'auto' }}>
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: selectedTab === 'Sabre',
                  'nav-link': true,
                })}
                onClick={() => {
                  setSelectedTab('Sabre');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${
                      selectedTab === 'Sabre' ? 'var(--theme-color-1)' : 'black'
                    }`,
                  }}
                >
                  Sabre
                </span>
              </NavLink>
            </NavItem>
          )}
          {rmsIntegrations !== undefined && (
            <NavItem className=" text-center" style={{ width: 'auto' }}>
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: selectedTab === 'RMS',
                  'nav-link': true,
                })}
                onClick={() => {
                  setSelectedTab('RMS');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${
                      selectedTab === 'RMS' ? 'var(--theme-color-1)' : 'black'
                    }`,
                  }}
                >
                  RMS
                </span>
              </NavLink>
            </NavItem>
          )}
          {/* <NavItem className=" text-center" style={{ width: 'auto' }}>
                        <NavLink
                            style={{ background: 'none', cursor: 'pointer' }}
                            className={classnames({
                                active: selectedTab === "roomimport",
                                "nav-link": true
                            })}
                            onClick={() => {
                                setSelectedTab("roomimport");
                            }}
                            to="#"
                        >
                            <span style={{ color: `${selectedTab === "roomimport" ? 'var(--theme-color-1)' : 'black'}` }}>Room Import</span>
                        </NavLink>
                    </NavItem> */}
          {/* <NavItem className=" text-center" style={{ width: 'auto' }}>
                        <NavLink
                            style={{ background: 'none', cursor: 'pointer' }}
                            className={classnames({
                                active: selectedTab === "translate",
                                "nav-link": true
                            })}
                            onClick={() => {
                                setSelectedTab("translate");
                            }}
                            to="#"
                        >
                            <span style={{ color: `${selectedTab === "translate" ? 'var(--theme-color-1)' : 'black'}` }}>Language Translate</span>
                        </NavLink>
                    </NavItem> */}
        </Nav>
      </CardHeader>
      <TabContent activeTab={selectedTab} className="">
        <TabPane tabId="textGeneration" className="chat-app-tab-pane">
          <Row className="mt-3 mb-2">
            <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
              <CardBody>
                <Col md="12" className="mt-2 mb-3">
                  <p className="mb-2">
                    You can give it links to your website(s), and it will
                    pre-fill about 250 sections of the Knowledge Hub with the
                    information from your web pages.
                  </p>
                  <p className="mb-2">
                    You can then review and make updates where needed.
                  </p>
                </Col>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <Input
                      style={{ height: '2.5rem' }}
                      type="text"
                      value={urls.url1}
                      placeholder="https://www.yourwebpage1.com"
                      onChange={(e) =>
                        setUrls({ ...urls, url1: e.target.value })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <Input
                      style={{ height: '2.5rem' }}
                      type="text"
                      value={urls.url2}
                      placeholder="https://www.yourwebpage2.com"
                      onChange={(e) =>
                        setUrls({ ...urls, url2: e.target.value })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <Input
                      style={{ height: '2.5rem' }}
                      type="text"
                      value={urls.url3}
                      placeholder="https://www.yourwebpage3.com"
                      onChange={(e) =>
                        setUrls({ ...urls, url3: e.target.value })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Col md={12} className="mb-3 text-end">
                    <p className="mb-3">
                      Fetching subpages will show the list of all the subpages.
                      In the next step, you can choose the subpages you want to
                      use for Sprint.
                    </p>
                    <Button
                      color="primary"
                      onClick={handleSubmit}
                      className={`btn-multiple-state ${classnames({
                        'show-spinner': ApiStateImport === 'processing',
                        'show-success': ApiStateImport === 'success',
                        'show-fail': ApiStateImport === 'fail',
                      })}`}
                    >
                      <span className="spinner d-inline-block">
                        <span className="bounce1" />
                        <span className="bounce2" />
                        <span className="bounce3" />
                      </span>
                      <span className="icon success">
                        <i className="simple-icon-check" />
                      </span>
                      <span className="icon fail">
                        <i className="simple-icon-exclamation" />
                      </span>
                      <span className="label">Fetch Subpages</span>
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Row>
          {urlList.length > 0 && (
            <Row className="mt-3 mb-2">
              <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
                <CardBody>
                  <Row className="ml-2 mb-2">
                    <CustomInput
                      key={'Selection'}
                      type="checkbox"
                      id="Selection"
                      label={'Select All'}
                      className="ml-3 mb-1"
                      checked={true}
                      onChange={(e) => handleSelectedAll(e.target.checked)}
                    />
                  </Row>
                  <Row className="ml-2">
                    {urlList.map((elem, index) => (
                      <Colxx md={6} className="mb-2 ">
                        {' '}
                        <CustomInput
                          key={index}
                          className="mb-2"
                          type="checkbox"
                          value={index}
                          id={index}
                          onChange={handleChange}
                          checked={elem.checked}
                        >
                          {elem.url}
                        </CustomInput>
                      </Colxx>
                    ))}
                  </Row>
                  <div className="my-2 d-flex justify-content-end">
                    <Col md={12} className="mb-3 text-end">
                      <Button
                        color="primary"
                        onClick={handleUpload}
                        className={`btn-multiple-state ${classnames({
                          'show-spinner': ApiImport === 'processing',
                          'show-success': ApiImport === 'success',
                          'show-fail': ApiImport === 'fail',
                        })}`}
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="icon success">
                          <i className="simple-icon-check" />
                        </span>
                        <span className="icon fail">
                          <i className="simple-icon-exclamation" />
                        </span>
                        <span className="label">Start Import</span>
                      </Button>
                      <p className="mt-3">
                        Importing will start a background job, and in about 15
                        minutes the Knowledge Hub will be ready with the
                        information from your web pages.
                      </p>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Row>
          )}
        </TabPane>

        <TabPane tabId="Sabre" className="chat-app-tab-pane">
          <Row className="mt-3 mb-2">
            <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
              <CardBody>
                <Col md="12" className="mt-2 mb-3">
                  <img
                    src={sync_sabre}
                    // style={{ width: '100%', height: '90px' }}
                  ></img>
                </Col>
                <Col md="12" className="mt-2 mb-3">
                  <p className="mb-2">
                    With integration to Sabre, you can sync hotel description
                    using Channel Connect API's, along with rooms types from
                    Sabre SynXis.
                  </p>
                  <p className="mb-2">
                    All the imported data is then readily available to train the
                    AI model for AI Chatbot, AI Voice, Email, and Agent Assist.
                    Includes:
                  </p>
                </Col>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <CustomInput
                      style={{ height: '2.5rem' }}
                      type="checkbox"
                      checked={sabreDetails.guestRooms ? true : false}
                      label="Room Types & Description"
                      placeholder="https://www.yourwebpage1.com"
                      onChange={(e) =>
                        setSabreDetails({
                          ...sabreDetails,
                          guestRooms: e.target.checked,
                        })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <CustomInput
                      style={{ height: '2.5rem' }}
                      type="checkbox"
                      checked={sabreDetails.propertyDescription ? true : false}
                      label="Property Description & amenities"
                      onChange={(e) =>
                        setSabreDetails({
                          ...sabreDetails,
                          propertyDescription: e.target.checked,
                        })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <CustomInput
                      style={{ height: '2.5rem' }}
                      type="checkbox"
                      checked={sabreDetails.conactInfo ? true : false}
                      label="Contact details"
                      onChange={(e) =>
                        setSabreDetails({
                          ...sabreDetails,
                          conactInfo: e.target.checked,
                        })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <CustomInput
                      style={{ height: '2.5rem' }}
                      type="checkbox"
                      checked={sabreDetails.locationInfo ? true : false}
                      label="Location"
                      onChange={(e) =>
                        setSabreDetails({
                          ...sabreDetails,
                          locationInfo: e.target.checked,
                        })
                      }
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <CustomInput
                      style={{ height: '2.5rem' }}
                      type="checkbox"
                      checked={sabreDetails.policies ? true : false}
                      label="Policies"
                      onChange={(e) =>
                        setSabreDetails({
                          ...sabreDetails,
                          policies: e.target.checked,
                        })
                      }
                    />
                  </Colxx>
                  <Colxx md={12}>
                    <p className="mb-2">
                      Save time and ensure accuracy by importing data from Sabre
                      SynXis.
                    </p>
                  </Colxx>
                  <Colxx md={12} className="mb-3 ml-4">
                    <ul className="mb-3">
                      <li>You can reimport the data anytime </li>
                      <li>All content updates are logged at Myma.ai</li>
                    </ul>
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Col md={12} className="mb-3 text-end">
                    <Button
                      color="primary"
                      onClick={handleSabre}
                      className={`btn-multiple-state ${classnames({
                        'show-spinner': ApiStateImport === 'processing',
                        'show-success': ApiStateImport === 'success',
                        'show-fail': ApiStateImport === 'fail',
                      })}`}
                    >
                      <span className="spinner d-inline-block">
                        <span className="bounce1" />
                        <span className="bounce2" />
                        <span className="bounce3" />
                      </span>
                      <span className="icon success">
                        <i className="simple-icon-check" />
                      </span>
                      <span className="icon fail">
                        <i className="simple-icon-exclamation" />
                      </span>
                      <span className="label">Sync</span>
                    </Button>
                  </Col>
                </Row>
                <Row></Row>
              </CardBody>
            </Card>
          </Row>
        </TabPane>
        <TabPane tabId="RMS" className="chat-app-tab-pane">
          <Row className="mt-3 mb-2">
            <Card style={{ width: '100%', borderRadius: '1.25rem' }}>
              <CardBody>
                {/* <Col md="12" className="mt-2 mb-3">
                  <img
                    src={RMSLogo}
                    // style={{ width: '100%', height: '90px' }}
                  ></img>
                </Col> */}
                <Col md="12" className="mt-2 mb-3">
                  <p className="mb-2">
                    With integration to Sabre, you can sync rooms types from
                    RMS.
                  </p>
                  <p className="mb-2">
                    All the imported data is then readily available to train the
                    AI model for AI Chatbot, AI Voice, Email, and Agent Assist.
                    Includes:
                  </p>
                </Col>
                <Row className="ml-1">
                  <Colxx md={5} className="mb-3">
                    <CustomInput
                      style={{ height: '2.5rem' }}
                      type="checkbox"
                      checked={isRMSRoomSelected ? true : false}
                      label="Room Types"
                      onChange={(e) => setIsRMSRoomSelected(e.target.checked)}
                    />
                  </Colxx>
                </Row>
                <Row className="ml-1">
                  <Col md={12} className="mb-3 text-end">
                    <Button
                      color="primary"
                      onClick={handleRMS}
                      className={`btn-multiple-state ${classnames({
                        'show-spinner': ApiStateImport === 'processing',
                        'show-success': ApiStateImport === 'success',
                        'show-fail': ApiStateImport === 'fail',
                      })}`}
                    >
                      <span className="spinner d-inline-block">
                        <span className="bounce1" />
                        <span className="bounce2" />
                        <span className="bounce3" />
                      </span>
                      <span className="icon success">
                        <i className="simple-icon-check" />
                      </span>
                      <span className="icon fail">
                        <i className="simple-icon-exclamation" />
                      </span>
                      <span className="label">Sync</span>
                    </Button>
                  </Col>
                </Row>
                <Row></Row>
              </CardBody>
            </Card>
          </Row>
        </TabPane>
      </TabContent>

      <TabContent activeTab={selectedTab} className="">
        <TabPane tabId="imageImport" className="chat-app-tab-pane">
          <ImagesImport
            propertyId={propertyId}
            textUrl={urls}
            setUrlsText={setUrls}
          ></ImagesImport>
        </TabPane>
      </TabContent>
      <TabContent activeTab={selectedTab} className="">
        <TabPane tabId="templates" className="chat-app-tab-pane">
          <Templates propertyId={propertyId}></Templates>
        </TabPane>
      </TabContent>
      {/* <TabContent activeTab={selectedTab} className="">
                <TabPane tabId="roomimport" className="chat-app-tab-pane">
                    <RoomImport
                        propertyId={propertyId}
                        locale={locale}
                    ></RoomImport>
                </TabPane>
            </TabContent> */}
      {/* <TabContent activeTab={selectedTab} className="">
                <TabPane tabId="translate" className="chat-app-tab-pane">
                    <LanguageTranslate
                        propertyId={propertyId}
                        locale={locale}
                    ></LanguageTranslate>
                </TabPane>
            </TabContent> */}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default connect(mapStateToProps, {})(Copilot);
